// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__SiqAZ","watermark":"Cards_watermark__8LTyr","leftWatermark":"Cards_leftWatermark__i5E90","cards":"Cards_cards__Buq3V"};